import * as angular from 'angular';

angular
  .module('screeningcanvas')
  .controller('ModalFatturaEasyCtrl', ModalFatturaEasyCtrl);

  ModalFatturaEasyCtrl.$inject = ['$scope', '$uibModalInstance'];

  function ModalFatturaEasyCtrl($scope, $uibModalInstance) {
    $scope.save = function () {
      $uibModalInstance.close({});
    };
    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }
